<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h3 class="mb-4">Admin Tracking</h3>
      </v-flex>
      <!-- <v-flex xs12>
        <v-select
          label="Priority for Element 5 Sync Calls"
          :items="['High', 'Medium', 'Low']"
          v-model="adminTracking.priority"
        >
        </v-select>
      </v-flex>
      <v-flex xs12>
        <v-select
          label="Status"
          :items="[
            'Completed',
            'On-Track',
            'Postponed',
            'Virtual',
            'Cancelled',
            'Unknown'
          ]"
          v-model="adminTracking.status"
        >
        </v-select>
      </v-flex> -->
      <v-flex xs12 md9 lg6>
        <v-text-field
          readonly
          flat
          outline
          label="Event ID:"
          v-model="this.editObject.id"
          ><template v-slot:label>
            <div><strong>Event ID:</strong></div>
          </template>
          <template v-slot:append>
            <v-tooltip left max-width="250">
              <template v-slot:activator="{ on }">
                <i
                  v-bind="attrs"
                  v-on="on"
                  class="fa fa-question-circle"
                  aria-hidden="true"
                ></i>
              </template>
              <p class="descrpop">
                Event ID is not editable, but you can copy and paste this value
                for reference.
              </p>
            </v-tooltip>
          </template></v-text-field
        >
      </v-flex>

      <v-flex xs12 md9 lg6>
        <v-text-field
          readonly
          flat
          outline
          label="Response Token:"
          v-model="this.editObject.token"
          ><template v-slot:label>
            <div><strong>Response Token:</strong></div> </template
          ><template v-slot:append>
            <v-tooltip left max-width="250">
              <template v-slot:activator="{ on }">
                <i
                  v-bind="attrs"
                  v-on="on"
                  class="fa fa-question-circle"
                  aria-hidden="true"
                ></i>
              </template>
              <p class="descrpop">
                Response Token is not editable, but you can copy and paste this
                value for reference.
              </p>
            </v-tooltip>
          </template></v-text-field
        >
      </v-flex>

      <v-flex xs12>
        <v-divider xs12 class="my-3"></v-divider>
      </v-flex>
      <v-flex xs12>
        <v-select
          label="Support Status*"
          v-model="adminTracking.support_status"
          :items="support_statuses"
          item-text="name"
          item-value="name"
          required
          :rules="rules.required"
        ></v-select>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          label="Status Notes"
          v-model="adminTracking.status_notes"
          rows="10"
        >
        </v-textarea>
      </v-flex>
      <v-flex xs12>
        <v-radio-group
          v-model="adminTracking.events_meeting"
          mandatory
          :rules="rules.bool"
        >
          <template v-slot:label>
            <div>
              Does this event need to be discussed at an events meeting?*
            </div>
          </template>
          <v-radio :value="true">
            <template v-slot:label>
              <div>Yes</div>
            </template>
          </v-radio>
          <v-radio :value="false">
            <template v-slot:label>
              <div>No</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12>
        <v-textarea
          label="Funding Mechanism"
          v-model="adminTracking.funding_mechanism"
          rows="3"
        >
        </v-textarea>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          label="Impact of Current Year Funding"
          v-model="adminTracking.impact"
        >
        </v-textarea>
      </v-flex>
      <!-- <v-flex xs12>
        <v-select
          label="DSEC Partners Participating"
          :items="['Yes', 'No']"
          v-model="adminTracking.partners_participating"
        >
        </v-select>
      </v-flex> -->
      <v-flex xs12 v-if="editObject.dsec_funded">
        <v-checkbox
          label="DSEC Event Planning Required?"
          v-model="adminTracking.pre_survey_required"
        >
        </v-checkbox>
        <!-- <v-checkbox
          label="Post-Event Form Required?"
          v-model="adminTracking.post_survey_required"
          v-if="`DISABLED` && false"
        >
        </v-checkbox>
        <v-checkbox
          label="After-Action Report Required?"
          v-model="adminTracking.action_report_required"
        >
        </v-checkbox> -->
      </v-flex>
      <v-flex xs12>
        <v-btn color="primary ma-0" @click="saveAdmin()" :disabled="disabled"
          >Save</v-btn
        >
        <v-btn
          @click="
            editObject.return == 'close'
              ? $emit('close')
              : $emit('view-event', 'event-view', editObject)
          "
          flat
          outline
          >Cancel</v-btn
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";
export default {
  mixins: [permissionsMixin],
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      adminTracking: {},
      editObject: {},
      disabled: false,
      // TODO: Can we get this from the backend api where
      // it can be configurable?
      support_statuses: [
        { name: "In Progress" },
        { name: "Waiting on DoD STEM" },
        { name: "Waiting on Partner" },
        { name: "Not Able to Support" },
        { name: "Completed" },
        { name: "No Support Requested" }
      ],
      test: [],
      rules: {
        required: [(v) => !!v || "This field is required."],
        bool: [(v) => v === true || v === false || "This field is required"]
      }
    };
  },
  methods: {
    async saveAdmin() {
      this.disabled = true;
      await this.$http.put("dsec/events/" + this.editObject.id, {
        admin_tracking: this.adminTracking
      });
      this.editObject.admin_tracking = this.adminTracking;
      this.disabled = false;
      EventBus.$emit("refreshEvents");
      this.$emit("close");
    }
  },
  mounted() {
    this.editObject = JSON.parse(JSON.stringify(this.item));

    if (!Array.isArray(this.editObject.admin_tracking)) {
      this.adminTracking = this.editObject.admin_tracking;
    }

    // If this isn't DSEC funded, then the survey links
    // aren't visible (per November 2021 requests). If
    // they aren't visible, then they shouldn't be required.
    if (!this.editObject.dsec_funded) {
      this.adminTracking.pre_survey_required = false;
      this.adminTracking.post_survey_required = false;
      this.adminTracking.action_report_required = false;
    }

    // dsec 2.0 doesn't have post survey or action reports
    this.adminTracking.post_survey_required = false;
    this.adminTracking.action_report_required = false;
  }
};
</script>

<style></style>
